import { useMemo } from 'react'

export interface UseResizeableColumnWidthProps {
  key: string
  userId?: string
  defaultWidth?: number
}

export function useResizeableColumnWidth ({ key, userId, defaultWidth = 240 }: UseResizeableColumnWidthProps): number {
  let resizeableColumnWidth = useMemo(() => {
    let value = localStorage.getItem(key)
    let width: number | undefined

    try {
      width = parseInt(value ?? '', 10)
    } catch (err) {}

    return typeof width === 'number'
      ? isNaN(width)
        ? defaultWidth
        : width ?? defaultWidth
      : defaultWidth
  }, [ key, defaultWidth ])

  return resizeableColumnWidth
}
